module.exports = __webpack_public_path__ + "img/adori-without-text.f73682bc.svg";